export default __webpack_public_path__ + "static/media/Simon.4cbc0524.png";